import { useDispatch } from "react-redux";

import _ from "lodash";

import { trackEventForAdoption } from "../adoption";
import {
  PAGE_VIEWED,
  TRACK_ADD_COLLECTION_LIST_SCREEN_VIEW,
  TRACK_ADD_PAGES_CLICKED_EVENT,
  TRACK_ADD_TO_COLLECTION_CLICKED_EVENT,
  TRACK_ANALYTICS_CLICKED_EVENT,
  TRACK_ASSET_ADDED,
  TRACK_ASSET_ANALYTICS_VIEWED_EVENT,
  TRACK_ASSET_CLONE_SCREEN_VIEW,
  TRACK_ASSET_CLONED_EVENT,
  TRACK_ASSET_CREATE_SCREEN_VIEW,
  TRACK_ASSET_DOWNLOAD_CLICKED,
  TRACK_ASSET_EDITED_EVENT,
  TRACK_ASSET_SELECTED_EVENT,
  TRACK_ASSET_SHARE_CLICKED_EVENT,
  TRACK_ASSET_SHARE_LINK_GENERATED_EVENT,
  TRACK_ASSET_SHARED_EVENT,
  TRACK_ASSET_SOURCE_SELECTED_EVENT,
  TRACK_ASSET_VIEWED_EVENT,
  TRACK_CLONE_ASSET_CLICKED_EVENT,
  TRACK_COLLECTION_SELECTED_EVENT,
  TRACK_DESTINATION_SELECTED,
  TRACK_DOCUMENT_EDIT_CLICKED_EVENT,
  TRACK_EDIT_ASSET_CLICKED_EVENT,
  TRACK_GENERATE_LINK_CLICKED,
  TRACK_GENERATE_LINK_EVENT,
  TRACK_ASSET_DOWNLOADED_EVENT,
  TRACK_GENERATE_LINK_SCREEN_VIEW,
  TRACK_PAGE_ADDED_EVENT,
  TRACK_ASSET_ADDED_TO_COLLECTION_EVENT,
  TRACK_ASSET_SCREEN_VIEW,
} from "src/constants/adoption/eventTypes";

import {
  TrackAssetCloneClicked,
  TrackAssetDownloadClicked,
  TrackAssetSelected,
  TrackAssetShareClicked,
  TrackAssetShared,
  TrackAssetSourceSelected,
  TrackCollectionSelected,
  TrackDestinationSelected,
  TrackGenerateLink,
  TrackGenerateLinkClicked,
  TrackAssetAnalyticsClicked,
  TrackAssetEdited,
  TrackAssetDownloadedEvent,
  TrackAssetViewed,
  TrackAssetAdded,
  TrackAssetAddToCollection
} from "src/types/adoption/asset";

import { DEAL_ROOM } from "src/constants/adoption/sourceTypes";
import { FileService } from "src/utils/file.service";

export const useAssetAdoption = () => {
  const dispatch = useDispatch();

  // screen events
  const trackAssetScreenView = (sourceCta) => {
    const event = {
      event: PAGE_VIEWED,
      properties: {
        screen_name: TRACK_ASSET_SCREEN_VIEW,
        source_cta: sourceCta,
      },
    };

    dispatch(trackEventForAdoption(event));
  };

  const trackAssetViewed = ({ sourceCta, assetType, sourceNameType, sourceName }: TrackAssetViewed) => {

    const properties = {
      source_cta: sourceCta,
      asset_type: assetType,
      [sourceNameType]: sourceName
    }

    const event = {
      event: TRACK_ASSET_VIEWED_EVENT,
      properties: properties
    }

    dispatch(trackEventForAdoption(event));
  }

  const trackAssetAnalyticsScreenView = () => {
    const event = {
      event: PAGE_VIEWED,
      properties: {
        screen_name: TRACK_ASSET_ANALYTICS_VIEWED_EVENT,
      },
    };

    dispatch(trackEventForAdoption(event));
  };

  const trackAssetCloneScreenView = () => {
    const event = {
      event: PAGE_VIEWED,
      properties: {
        screen_name: TRACK_ASSET_CLONE_SCREEN_VIEW,
      },
    };

    dispatch(trackEventForAdoption(event));
  };

  const trackAddToCollectionScreenView = () => {
    const event = {
      event: PAGE_VIEWED,
      properties: {
        screen_name: TRACK_ADD_COLLECTION_LIST_SCREEN_VIEW,
      },
    };

    dispatch(trackEventForAdoption(event));
  };

  const trackGenerateLinkScreenView = () => {
    const event = {
      event: PAGE_VIEWED,
      properties: {
        screen_name: TRACK_GENERATE_LINK_SCREEN_VIEW,
      },
    }

    dispatch(trackEventForAdoption(event));
  }

  // click events
  const trackAssetShareClickedEvent = ({
    assetType,
    shareMedium,
  }: TrackAssetShareClicked) => {
    const event = {
      event: TRACK_ASSET_SHARE_CLICKED_EVENT,
      properties: {
        asset_type: assetType,
        share_medium: shareMedium,
      },
    };

    dispatch(trackEventForAdoption(event));
  };

  const trackAssetDownloadEvent = ({
    assetType,
  }: TrackAssetDownloadClicked) => {
    const event = {
      event: TRACK_ASSET_DOWNLOAD_CLICKED,
      properties: {
        asset_type: assetType
      },
    };

    dispatch(trackEventForAdoption(event));
  };

  const trackAssetAnalyticsClicked = ({
    assetType
  }: TrackAssetAnalyticsClicked) => {
    const event = {
      event: TRACK_ANALYTICS_CLICKED_EVENT,
      properties: {
        asset_type: assetType,
      },
    };

    dispatch(trackEventForAdoption(event));
  }

  const trackAssetCloneClicked = ({
    assetType,
  }: TrackAssetCloneClicked) => {
    const event = {
      event: TRACK_CLONE_ASSET_CLICKED_EVENT,
      properties: {
        asset_type: assetType
      },
    };

    dispatch(trackEventForAdoption(event));
  };

  const trackGenerateLinkClicked = ({
    assetType,
    sourceCta
  }: TrackGenerateLinkClicked) => {
    const event = {
      event: TRACK_GENERATE_LINK_CLICKED,
      properties: {
        asset_type: assetType,
        source_cta: sourceCta
      },
    };

    dispatch(trackEventForAdoption(event));
  };

  const trackAddCollectionClicked = ({ assetType }) => {
    const event = {
      event: TRACK_ADD_TO_COLLECTION_CLICKED_EVENT,
      properties: {
        asset_type: assetType,
      },
    };

    dispatch(trackEventForAdoption(event));
  };

  const trackAssetAdded = ({
    type, entity, asset, source
  }: TrackAssetAdded) => {
    let properties = {

    };

    if (asset) {
      properties = {
        ...properties,
        asset_type: FileService.getFileType(asset.metadata)
      }
    }

    switch (type) {
      case 'collection': {
        if (entity) {
          const name = _.get(entity, 'name');
          properties = {
            ...properties,
            source_cta: 'Collection Edit',
            collection_name: name
          };
        } else {
          properties = {
            ...properties,
            source_cta: 'Collection Create',
          };
        }

        break;
      }
      case 'compose': {
        properties = {
          ...properties,
          source_cta: 'Compose',
        };

        break;
      }
      case 'stream': {
        if (entity) {
          const name = _.get(entity, 'name');
          properties = {
            ...properties,
            source_cta: 'Stream',
            stream_name: name
          };
        }

        break;
      }
      case 'group': {
        if (entity) {
          const name = _.get(entity, 'name');
          const stream = _.get(entity, 'stream.name');
          properties = {
            ...properties,
            source_cta: 'Group',
            stream_name: stream,
            group_name: name
          };
        }

        break;
      }
      case 'dealRoom': {
        if (entity) {
          const name = _.get(entity, 'name');
          properties = {
            ...properties,
            source_cta: DEAL_ROOM,
            dealroom_name: name
          };
        }

        break;
      }
    }

    switch (source) {
      case 'existing_assets': {
        properties = {
          ...properties,
          source_type: 'Streams and Collections'
        }

        break;
      }
      case 'file': {
        properties = {
          ...properties,
          source_type: 'Drag and Drop'
        }

        break;
      }
      case 'cleverstory': {
        properties = {
          ...properties,
          source_type: 'Cleverstory'
        }

        break;
      }
      case 'link': {
        properties = {
          ...properties,
          source_type: 'Add Content URL'
        }

        break;
      }
    }

    const event = {
      event: TRACK_ASSET_ADDED,
      properties: properties,
    };

    dispatch(trackEventForAdoption(event));
  };

  const trackCollectionSelected = ({
    assetType,
    collectionName,
    sectionName,
  }: TrackCollectionSelected) => {
    const event = {
      event: TRACK_COLLECTION_SELECTED_EVENT,
      properties: {
        asset_type: assetType,
        collection_name: collectionName,
        section_name: sectionName,
      },
    };

    dispatch(trackEventForAdoption(event));
  };

  const trackAssetAddToCollection = ({
    entity, asset
  }: TrackAssetAddToCollection) => {

    const fileType = FileService.getFileType(asset.metadata);

    let properties: any = {
      asset_type: fileType,
    }

    const entityType = _.get(entity, 'entityType');
    const name = _.get(entity, 'name');
    if (entityType === 'collection') {
      properties = {
        ...properties,
        collection_name: name
      }
    } else if (entityType === 'collection_section') {
      properties = {
        ...properties,
        section_name: name
      }
    }

    const event = {
      event: TRACK_ASSET_ADDED_TO_COLLECTION_EVENT,
      properties: properties
    }

    dispatch(trackEventForAdoption(event));
  }

  const trackEditAssetClicked = ({ assetType }) => {
    const event = {
      event: TRACK_EDIT_ASSET_CLICKED_EVENT,
      properties: {
        asset_type: assetType,
      },
    };

    dispatch(trackEventForAdoption(event));
  };

  const trackAssetEdited = ({ sourceCta, response, sectionType }: TrackAssetEdited) => {
    const extension = _.get(response, "metadata");
    const assetType = FileService.getFileType(extension);

    const externalDescription = _.get(response, "externalSummary")
      ? "Yes"
      : "No";
    const internalDescription = _.get(response, "summary")
      ? "Yes"
      : "No";

    const tags = _.get(response, "tags");
    const shareAccess = _.get(response, "settings.share")
      ? "Yes"
      : "No";
    const downloadAccess = _.get(response, "settings.download")
      ? "Yes"
      : "No";

    const categories = {};
    _.forEach(_.get(response, "customFields", []), (item) => {
      const name = _.lowerCase(item.name);
      const values = _.map(item.value, "value");
      categories[name] = values;
    });

    const event = {
      event: TRACK_ASSET_EDITED_EVENT,
      properties: {
      asset_type: assetType,
      internal_description: internalDescription,
      external_description: externalDescription,
      tags: tags,
      share_access: shareAccess,
      download_access: downloadAccess,
      categories: categories,
      source_cta: sourceCta,
      ...(sectionType && { content_section_type: sectionType })
      },
    };

    dispatch(trackEventForAdoption(event));
  };

  const trackAssetCloned = ({ assetType, destinationType, collectionName, streamName }) => {
    const event = {
      event: TRACK_ASSET_CLONED_EVENT,
      properties: {
        asset_type: assetType,
        destination_type: destinationType,
        collection_name: collectionName,
        stream_name: streamName
      },
    };

    dispatch(trackEventForAdoption(event));
  };

  const trackAddPagesClicked = () => {
    const event = {
      event: TRACK_ADD_PAGES_CLICKED_EVENT,
      properties: {},
    };

    dispatch(trackEventForAdoption(event));
  };

  const trackDestinationSelected = ({
    assetType,
    destinationType,
    sourceCta,
    collectionName,
    streamName,
  }: TrackDestinationSelected) => {
    const event = {
      event: TRACK_DESTINATION_SELECTED,
      properties: {
        asset_type: assetType,
        destination_type: destinationType,
        source_cta: sourceCta,
        collection_name: collectionName,
        stream_name: streamName,
      },
    };

    dispatch(trackEventForAdoption(event));
  };

  const trackPageAdded = () => {
    const event = {
      event: TRACK_PAGE_ADDED_EVENT,
      properties: {},
    };

    dispatch(trackEventForAdoption(event));
  };

  const trackDocumentClicked = () => {
    const event = {
      event: TRACK_DOCUMENT_EDIT_CLICKED_EVENT,
      properties: {},
    };

    dispatch(trackEventForAdoption(event));
  };

  const trackAssetSourceSelected = ({
    type, entity, source
  }: TrackAssetSourceSelected) => {

    let properties = {};

    switch (type) {
      case 'collection': {
        if (entity) {
          const name = _.get(entity, 'name');
          properties = {
            ...properties,
            source_cta: 'Collection Edit',
            collection_name: name
          };
        } else {
          properties = {
            ...properties,
            source_cta: 'Collection Create',
          };
        }

        break;
      }
      case 'stream': {
        if (entity) {
          const name = _.get(entity, 'name');
          properties = {
            ...properties,
            source_cta: 'Stream',
            stream_name: name
          };
        }

        break;
      }
      case 'group': {
        if (entity) {
          const name = _.get(entity, 'name');
          const stream = _.get(entity, 'stream.name');
          properties = {
            ...properties,
            source_cta: 'Group',
            stream_name: stream,
            group_name: name
          };
        }

        break;
      }
      case 'compose': {
        properties = {
          ...properties,
          source_cta: 'Compose',
        };

        break;
      }
    }

    switch (source) {
      case 'existing_assets': {
        properties = {
          ...properties,
          source_type: 'Streams and Collections'
        }

        break;
      }
      case 'file': {
        properties = {
          ...properties,
          source_type: 'Drag and Drop'
        }

        break;
      }
      case 'cleverstory': {
        properties = {
          ...properties,
          source_type: 'Cleverstory'
        }

        break;
      }
      case 'link': {
        properties = {
          ...properties,
          source_type: 'Add Content URL'
        }

        break;
      }
    }

    const event = {
      event: TRACK_ASSET_SOURCE_SELECTED_EVENT,
      properties: properties,
    };

    dispatch(trackEventForAdoption(event));
  };

  const trackAssetSelected = ({
    type, entity, asset, source
  }: TrackAssetSelected) => {

    let properties = {

    };

    if (asset) {
      properties = {
        ...properties,
        asset_type: FileService.getFileType(asset.metadata)
      }
    }

    switch (type) {
      case 'collection': {
        if (entity) {
          const name = _.get(entity, 'name');
          properties = {
            ...properties,
            source_cta: 'Collection Edit',
            collection_name: name
          };
        } else {
          properties = {
            ...properties,
            source_cta: 'Collection Create',
          };
        }

        break;
      }
      case 'stream': {
        if (entity) {
          const name = _.get(entity, 'name');
          properties = {
            ...properties,
            source_cta: 'Stream',
            stream_name: name
          };
        }

        break;
      }
      case 'group': {
        if (entity) {
          const name = _.get(entity, 'name');
          const stream = _.get(entity, 'stream.name');
          properties = {
            ...properties,
            source_cta: 'Group',
            stream_name: stream,
            group_name: name
          };
        }

        break;
      }
      case 'compose': {
        properties = {
          ...properties,
          source_cta: 'Compose',
        };

        break;
      }
    }

    switch (source) {
      case 'existing_assets': {
        properties = {
          ...properties,
          source_type: 'Streams and Collections'
        }

        break;
      }
      case 'file': {
        properties = {
          ...properties,
          source_type: 'Drag and Drop'
        }

        break;
      }
      case 'cleverstory': {
        properties = {
          ...properties,
          source_type: 'Cleverstory'
        }

        break;
      }
      case 'link': {
        properties = {
          ...properties,
          source_type: 'Add Content URL'
        }

        break;
      }
    }

    const event = {
      event: TRACK_ASSET_SELECTED_EVENT,
      properties: properties,
    };

    dispatch(trackEventForAdoption(event));
  };

  const trackAssetShared = ({ assetType, shareMedium }: TrackAssetShared) => {
    const event = {
      event: TRACK_ASSET_SHARED_EVENT,
      properties: {
        asset_type: assetType,
        share_medium: shareMedium
      },
    };

    dispatch(trackEventForAdoption(event));
  };

  const trackGenerateLink = ({ sourceCta, linkType, collectionName }: TrackGenerateLink) => {
    const event = {
      event: TRACK_GENERATE_LINK_EVENT,
      properties: {
        source_cta: sourceCta,
        link_type: linkType,
        collection_name: collectionName
      },
    };

    dispatch(trackEventForAdoption(event));
  };

  const trackAssetShareLinkGenerated = () => {
    const event = {
      event: TRACK_ASSET_SHARE_LINK_GENERATED_EVENT,
      properties: {},
    }

    dispatch(trackEventForAdoption(event));
  }

  const trackAddAssetScreenView = () => {
    const event = {
      event: PAGE_VIEWED,
      properties: {
        screen_name: TRACK_ASSET_CREATE_SCREEN_VIEW,
      }
    }

    dispatch(trackEventForAdoption(event));
  }

  const trackAssetDownloadedEvent = ({ collectionName, assetType }: TrackAssetDownloadedEvent) => {
    const event = {
      event: TRACK_ASSET_DOWNLOADED_EVENT,
      properties: {
        collection_name: collectionName,
        asset_type: assetType
      },
    };

    dispatch(trackEventForAdoption(event));
  };

  return {
    trackAssetScreenView,
    trackAssetAnalyticsScreenView,
    trackAssetCloneScreenView,
    trackAddToCollectionScreenView,
    trackGenerateLinkScreenView,
    trackAssetAnalyticsClicked,
    trackAssetShareClickedEvent,
    trackAssetDownloadEvent,
    trackAssetDownloadedEvent,
    trackAssetCloneClicked,
    trackGenerateLinkClicked,
    trackAddCollectionClicked,
    trackCollectionSelected,
    trackAssetAddToCollection,
    trackEditAssetClicked,
    trackAddPagesClicked,
    trackDestinationSelected,
    trackDocumentClicked,
    trackAssetSourceSelected,
    trackAssetSelected,
    trackAssetShared,
    trackGenerateLink,
    trackAssetShareLinkGenerated,
    trackPageAdded,
    trackAssetAdded,
    trackAssetEdited,
    trackAssetCloned,
    trackAddAssetScreenView,
    trackAssetViewed
  };
};
